<template>
  <div class="documentation-list-item-header">
    <i class="pi pi-file documentation-list-item-header__icon" />
    <div class="documentation-list-item-header__content">
      <div class="documentation-list-item-header__title">
        Dokumentasjon fra tilbud
      </div>
      <div class="documentation-list-item-header__subtitle">
        {{ date }}
      </div>
    </div>
    <div class="documentation-list-item-header__status">
      <span class="documentation-list-item-header__status-tag">
        <i class="pi pi-check" />
        Lagret
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  date: string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.documentation-list-item-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: $bp-sm) {
    align-items: center;
  }

  &__icon {
    font-size: 1.5rem;
    color: $color-primary;
    margin-top: 0.125rem;

    @media (max-width: $bp-sm) {
      font-size: 1.25rem;
      margin-top: 0;
    }
  }

  &__content {
    flex: 1;
  }

  &__title {
    font-size: 1rem;
    font-weight: 600;
    color: $color-text-primary;
    margin-bottom: 0.25rem;
  }

  &__subtitle {
    font-size: 0.875rem;
    color: $color-text-secondary;
  }

  &__status {
    display: flex;
    align-items: center;
  }

  &__status-tag {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.375rem 0.75rem;
    background-color: rgba($color-success, 0.1);
    color: $color-black;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;

    i {
      font-size: 0.75rem;
    }
  }
}
</style>
